import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../../redux/actions/data-action';
import { ScreenContainer } from './common';
import { Box, Button } from '@material-ui/core';
import { DemoQuestionText } from '../demographics/common/controls';
import MHSLogo from '../../logo.png';

class LoginScreen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			password: '',
			passwordRequiredError: false,
			hasError: false,
			errorMessage: ''
		};

		this.setPassword = this.setPassword.bind(this);
		this.onLogin = this.onLogin.bind(this);
	}

	componentDidMount() {
		const resumeExpiry = parseInt(localStorage.getItem('resumeExpiry'));

		if (resumeExpiry && new Date() > resumeExpiry) {
			localStorage.clear();
		}
	}

	setPassword(e) {
		const state = { password: e.target.value };

		this.setState(prevState => {
			if (prevState.passwordRequiredError) {
				state.passwordRequiredError = false;
			}

			if (prevState.errorMessage) {
				state.errorMessage = '';
			}

			return state;
		});
	}

	onLogin(e) {
		e.preventDefault();
		const { isLoading, password } = this.state;
		const { history, login, logToSentry } = this.props;

		if (isLoading) {
			return;
		}

		if (!password) {
			this.setState({
				passwordRequiredError: !password,
				hasError: false
			});

			return;
		}

		this.setState({
			isLoading: true,
			hasError: false,
			errorMessage: ''
		});

		login(
			{ password },
			data => {
				if ('success' in data) {
					logToSentry('info', `User Login`);
					history.push('/Home');
				} else {
					this.setState({
						isLoading: false,
						hasError: true,
						errorMessage: data.message
					});
				}
			},
			err => {
				this.setState({
					isLoading: false,
					hasError: true,
					errorMessage: err.data.error.message
				});
			}
		);
	}

	render() {
		const d = new Date();
		const {
			isLoading,
			password,
			passwordRequiredError,
			hasError,
			errorMessage
		} = this.state;

		return (
			<ScreenContainer>
				<Box className="login-header">
					<h1 className="text-center mb-4">
						<img className="login-logo" width="200" height="78" src={MHSLogo} alt="MHS Education" />
					</h1>
					<h2 className="text-center">Student Login</h2>
				</Box>
				<form className="login-form" onSubmit={this.onLogin} autoComplete="off">
					<p className="text-center">Please enter your access code.</p>
					{hasError && <p className="error-message">{errorMessage}</p>}
					<DemoQuestionText
						name="password"
						required={true}
						requiredError={passwordRequiredError}
						placeholder="ACCESS CODE"
						value={password}
						inputProps={{maxLength: 8}}
						onChange={this.setPassword} />
					<Button type="submit" className="login-button" disabled={isLoading}>{isLoading ? 'Please wait...' : 'LOG IN'}</Button>
				</form>
				<p className="copyright small">
					Copyright &copy; {d.getFullYear()} Multi-Health Systems, Inc. (MHS, Inc.) All rights reserved.
				</p>
            </ScreenContainer>
		);
	}
}

export default connect(null, actionCreator)(LoginScreen);